import React, { useEffect } from 'react'
import NavigationBar from '../components/NavigationBar'
import Banner from '../components/Banner'
import About from '../components/About'
import Features from '../components/Features'
// import Partner from '../components/Partner'
import ChooseUs from '../components/ChooseUs'
import Services from '../components/Services'
import Speciality from '../components/Speciality'
// import Gallery from '../components/Gallery'
// import Team from '../components/Team'
import Testimonials from '../components/Testimonials'
import Blog from '../components/Blog'
import Footer from '../components/Footer'
import RenderLinks from '../components/RenderLinks'

function Home() {
  // useEffect(()=>{
  //   const script1 = document.createElement('script');
  //   script1.src = 'static/js/main.js';
  //   script1.async = true;
  //   document.getElementsByClassName('wrapper')[0].appendChild(script1)
  //   return ()=>{
  //     document.getElementsByClassName('wrapper')[0].removeChild(script1)
  //   }
  // },[])
  return (
    <div>
      <RenderLinks/>
      <NavigationBar/>
      <Banner/>
      <About/>
      <Features/>
      
      <ChooseUs/>
      <Services/>
      <Speciality/>
      <Testimonials/>
      <Blog/>
      <Footer/>
    </div>
  )
}

export default Home
